// extracted by mini-css-extract-plugin
module.exports = {"search-list":"search-list___vvgnL","search-box-wrapper":"search-box-wrapper___1UfGC","search-box":"search-box___3xoNO","list":"list___2CTUa","line":"line___2KeUZ"};